import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Card, CardBody, CardHeader } from 'reactstrap';

const STATE_LABELS = {
  new: 'Nuevo',
  assigned: 'Asignado',
  negotiation: 'Negociación',
  visit: 'Visita',
  close: 'Cerrado',
  completed: 'Completado',
};

const COLORS = [
  '#4dc9f6',
  '#f67019',
  '#f53794',
  '#537bc4',
  '#acc236',
  '#166a8f',
];

const LeadFunnelChart = ({ funnel }) => {
  if (!funnel || funnel.length === 0) return null;

  const data = {
    labels: funnel.map((f) => STATE_LABELS[f.state] || f.state),
    datasets: [
      {
        label: 'Cantidad de Leads',
        data: funnel.map((f) => f.count),
        backgroundColor: COLORS,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: { beginAtZero: true, precision: 0 },
        },
      ],
    },
    legend: { display: false },
  };

  return (
    <Card className="mb-4">
      <CardHeader>Embudo de Leads</CardHeader>
      <CardBody style={{ height: '300px' }}>
        <Bar data={data} options={options} />
      </CardBody>
    </Card>
  );
};

export default LeadFunnelChart;
